import { put, takeEvery } from "redux-saga/effects";

import faqService from "../../../services/faq";
import { getFaqStart, getFaqSuccess, getFaqFailure } from "../../redux/Faq";
// import { showErrorMessage } from "../../redux/toast";

function* faqWatcher() {
  yield takeEvery(getFaqStart.type, faqWorker);
}

function* faqWorker(action) {
  try {
    const { data, error } = yield faqService.getfaqData(action.payload);
    if (!error) {
      yield put(getFaqSuccess(data));
    }
    if (error) {
      // yield put(showErrorMessage({ msg: error.message }));
      yield put(getFaqFailure());
    }
  } catch (error) {
    // yield put(showErrorMessage({ msg: error.message }));
    yield put(getFaqFailure());
  }
}

export default faqWatcher;
